// 扫一扫
import Vue from 'vue'
import { isOnlyWechat, isFeishu, isOnlyWeCom, isDingding } from '@/lib/ui/utils/platform.util.js'
// 微信扫码
import { wxScanQRCode } from '../wx-sdk'
// 飞书扫码
import { feishuScanQRCode } from '../feishu-sdk'
// 企微扫码
import { weComScanQRCode } from '../we-com-sdk'
// else if (isOnlyWeCom() && Vue.prototype.$weComConfigStatus === true) {
//   weComScanQRCode((result) => {
//     if (result) {
//       resolve(result)
//     } else {
//       reject(new Error())
//     }
//   })
// }
// 钉钉扫码
import { dingdingScanQRCode } from '../dingding-sdk'
export function scanQRCode() {
  return new Promise((resolve, reject) => {
    if (isOnlyWechat()) {
      wxScanQRCode((result) => {
        if (result) {
          resolve(result)
        } else {
          reject(new Error())
        }
      })
      // weComScanQRCode((result) => {
      //   if (result) {
      //     resolve(result)
      //   } else {
      //     reject(new Error())
      //   }
      // })
    } else if (isFeishu()) {
      feishuScanQRCode((result) => {
        if (result) {
          resolve(result)
        } else {
          reject(new Error())
        }
      })
    } else if (isOnlyWeCom() && Vue.prototype.$weComConfigStatus === true) {
      weComScanQRCode((result) => {
        if (result) {
          resolve(result)
        } else {
          reject(new Error())
        }
      })
    } else if (isDingding()) {
      dingdingScanQRCode((result) => {
        if (result) {
          resolve(result)
        } else {
          reject(new Error())
        }
      })
    } else {
      // if (Vue.prototype.$deviceInfo === null && navigator.mediaDevices) {
      //   try {
      //     navigator.mediaDevices.enumerateDevices()
      //       .then((device) => {
      //         Vue.prototype.$deviceInfo = device
      //         h5ScanQRCode(resolve, reject)
      //       })
      //   } catch (e) {
      //     Vue.prototype.$deviceInfo = undefined
      //     h5ScanQRCode(resolve, reject)
      //   }
      // } else {
      //   h5ScanQRCode(resolve, reject)
      // }
      h5ScanQRCode(resolve, reject)
    }
  })
}

function h5ScanQRCode(resolve, reject) {
  Vue.prototype.$scanModalOptEvent.showGlobalScanModal((result) => {
    if (result) {
      resolve(result)
    } else {
      reject(new Error())
    }
  })
}
